import type { EntityState } from '../../lib/api.js';
import { friendlyName } from '../../lib/utils.js';

interface Props {
  entityId: string;
  entity: EntityState;
}

export function DefaultCard({ entityId, entity }: Props) {
  return (
    <div
      className="p-4 rounded-xl border"
      style={{ backgroundColor: 'var(--ac-surface)', borderColor: 'var(--ac-border)' }}
    >
      <div className="text-sm text-[var(--ac-text-muted)]">
        {friendlyName(entityId, entity.attributes)}
      </div>
      <div className="font-medium text-[var(--ac-text)] mt-1">{entity.state}</div>
      <div className="text-xs text-[var(--ac-text-muted)] mt-1">{entityId}</div>
    </div>
  );
}
